module.exports = __webpack_public_path__ + "static/media/belajar1.3ba1400c.jpeg";